export default class XConstants {
  static apiDomain = process.env.REACT_APP_API_DOMAIN;
  static baseUrl = process.env.REACT_APP_BASE_URL;
  static httpPrefix = process.env.REACT_APP_HTTP_PREFIX;
}
